import { useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import Popper from "@mui/material/Popper";
import SearchIcon from "@mui/icons-material/Search";
import { cityOptions } from "../constants/enums";
import { LocationSearch } from "./svg";

const CustomPopper = (props) => (
    <Popper
        {...props}
        placement="bottom-start"
        modifiers={[
            {
                name: "offset",
                options: {
                    offset: [0, 8],
                },
            },
        ]}
    />
);

export function MapCitySearch({ onSelect }) {
    const [expanded, setExpanded] = useState(false);

    return (
        <div

            className={`flex items-center gap-2  rounded-full px-2 py-1 bg-white relative overflow-hidden transition-all duration-600 
            ${expanded ? "w-[190px] bg-gray-100 shadow border-orange-300 pl-4" : "w-[40px]"} flex-row-reverse -mr-1`}
        >
            <div className=" cursor-pointer"
                onClick={() => {
                    if (expanded) {
                        setExpanded(false);
                    } else {
                        setExpanded(true)
                    }
                }}
            ><LocationSearch /></div>
            {expanded && (
                <Autocomplete
                    id="map-city-search"
                    options={cityOptions}
                    getOptionLabel={(option) => option.name || ""}
                    renderOption={(props, option, { index }) => {
                        const isLast = index === cityOptions.length - 1;
                        return (
                            <li
                                {...props}
                                className={`
                                    px-2 py-0.5 text-[12px] text-gray-700 font-medium 
                                    ${!isLast ? "border-b border-gray-200" : ""}
                                    hover:bg-gray-100 cursor-pointer transition-colors
                                `}
                            >
                                {option.name}
                            </li>
                        );
                    }}

                    renderInput={(params) => (
                        <div ref={params.InputProps.ref} className="flex-1">
                            <input type="text" placeholder="Search location..." {...params.inputProps} className="w-full text-gray-500 text-[13px] font-medium bg-transparent border-none outline-none" />
                        </div>
                    )}
                    PopperComponent={CustomPopper}
                    componentsProps={{
                        paper: {
                            sx: {
                                width: "100%",
                                overflowY: "auto",
                            },
                        },
                    }}
                    onChange={(event, value) => {
                        if (value && onSelect) {
                            onSelect(value);
                        }
                    }}
                    sx={{ flex: 1 }}
                />
            )}
        </div>
    );
}

export default MapCitySearch;
